import React, { useEffect } from 'react';
import WorksCard from '../../components/works-card/WorksCard'
import Nav from '../../components/nav/Nav';
import BotDiv from '../../components/botdiv/BotDiv'
import Loader from '../../components/preloader/Loader';

function Allworks({ loaderFinished, setLoaderFinished }) {
  useEffect(()=>{
    setLoaderFinished(false);
  },[setLoaderFinished]);
  
  return (
    <div className='works'>
      <Loader loaderFinished={setLoaderFinished} data="works" show2={false} />
      {loaderFinished && (
      <>
      <Nav inHome={false}/>
        <div className="work-container slide-in-top-animation">
            <div className="work-desc">
                <h3>Creating quality websites & web designs.</h3>
            </div>
            <div className="projects">
              <p className="recent-works">RECENT WORKS</p>
              <WorksCard showAll={true}/>
            </div>
        </div>
        <BotDiv/>
      </>
      )}
    </div>
  )
}

export default Allworks